import React from 'react';
import classNames from 'classnames';
import { Typography } from '@mui/material';

import styles from './TravelLinks.module.scss';

export const TravelLinks: React.FC = () => {
  const subject = 'Surfline Travel User Feedback';
  const email = 'travelsupport@surfline.com';
  return (
    <section
      className={classNames(styles.links, 'sl-section-container')}
      data-testid="travel-links"
      id="links"
    >
      <Typography className={styles.text} variant="h5" component="p">
        Have feedback on this zone? Let us know{' '}
        <a className={styles.link} href={`mailto:${email}?subject=${subject}`}>
          travelsupport@surfline.com
        </a>
      </Typography>
      <Typography className={styles.text} variant="h5" component="p">
        Questions about booking with Surfline Travel?{' '}
        <a
          className={styles.link}
          target="_blank"
          href="https://support.surfline.com/hc/en-us/categories/5227934822939-Travel-"
          rel="noopener noreferrer"
        >
          Check out our FAQs
        </a>
      </Typography>
    </section>
  );
};

export default TravelLinks;
